<template>
    <div>
      <v-snackbar v-model="snackView" centered :color="color" :timeout="timeout">
        <v-row justify="center" align="center">
          <v-col cols="3">
            <v-icon size="50">{{ icon }}</v-icon>
          </v-col>
          <v-col cols="9" class="text-h6">
            {{ texto }}
          </v-col>
        </v-row>
      </v-snackbar>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex"
  export default {
    name: "SnackBar",
    data() {
      return {
        snackView: false,
        color: "",
        timeout: "3000",
        icon: "mdi-alert",
        texto: "alerta",
      }
    },
    computed: {
      ...mapState(['showAlert', 'dataAlert']),
    },
    watch: {
      //verifica el valor en el state y la cambia dependiendo el valor (false o true)
      showAlert(val) {
        val ? this.snackView = true : this.snackView = false
      },
      //Settea los datos que llegan desde el state
      dataAlert(val) {
        this.timeout = val.timeout
        this.color = val.color
        this.icon = val.icon
        this.texto = val.texto
      }
    }
  
  };
  </script>